var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1116 15.0208L11.4316 3.45C11.1366 2.93833 10.5899 2.62333 9.99991 2.62333C9.40991 2.62333 8.86324 2.93833 8.56824 3.45L1.88824 15.0208C1.59324 15.5325 1.59324 16.1617 1.88824 16.6742C2.18324 17.185 2.72908 17.5 3.31991 17.5H16.6807C17.2707 17.5 17.8174 17.185 18.1124 16.6733C18.4074 16.1617 18.4074 15.5325 18.1116 15.0208Z",
    fill: "#E85048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9826 14.7883C10.9826 15.0825 10.8117 15.8333 9.99508 15.8333C9.17841 15.8333 9.01758 15.0817 9.01758 14.7883C9.01758 14.5008 9.19925 13.7308 9.99508 13.7308C10.7909 13.7308 10.9826 14.5008 10.9826 14.7883ZM9.09924 11.5992V7.97333C9.09924 7.47583 9.50258 7.0725 10.0001 7.0725C10.4976 7.0725 10.9009 7.47583 10.9009 7.97333V11.6C10.9009 12.0967 10.4976 12.5 10.0001 12.5C9.50258 12.5 9.09924 12.0967 9.09924 11.5992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f0ef60cf92f287eeb9594396d8297c98.svg";
export { ForwardRef as ReactComponent };